import { useState, useCallback } from "react";
import { saveDocumentURL } from "../../utils/ConstantsURL";

export const useSaveDocument = (token) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const saveDocument = useCallback(
    async (documentData) => {
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(saveDocumentURL(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(documentData),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Error al crear el documento");
        }

        setData(result);
        return { success: true, data: result };
      } catch (err) {
        const errorMessage = err.message || "Error en la conexión";
        setError(errorMessage);
        return { success: false, error: errorMessage };
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  return { saveDocument, loading, error, data };
};

export default useSaveDocument;
